import { createContext, useContext } from 'react';
export const SuccessToastContext = createContext({
    isSuccessToastVisible: false,
    setIsSuccessToastVisible: () => { }
});
export const useSuccessToastContext = () => useContext(SuccessToastContext);
